import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';

import removeBlankProperties from 'utils/removeBlankProperties';

function makeVisitorIdentity(user = {}) {
  const {
    email,
    firstName,
    lastName,
    username,
    role,
    superuser: isSuperUser,
    sentinelTeam = {},
    oemSegments = [],
  } = user;

  /* istanbul ignore next -- @preserve */
  const { oemSegment = {} } = sentinelTeam || {};

  const isOemManager =
    isEmpty(oemSegment) || isEmpty(oemSegments)
      ? false
      : oemSegments.some((seg) => seg.id === oemSegment.id);

  const appRoles = compact([
    isSuperUser ? 'superuser' : null,
    isOemManager ? 'oem_segment_manager' : null,
    role?.name || null,
  ]);

  return removeBlankProperties({
    id: email,
    email,
    firstName,
    lastName,
    username,
    appRoles,
    appName: 'sentinel',
  });
}

export default makeVisitorIdentity;
